import { render, staticRenderFns } from "./userAccessMgmtCreate.vue?vue&type=template&id=05a3b6e6&"
import script from "./userAccessMgmtCreate.vue?vue&type=script&lang=js&"
export * from "./userAccessMgmtCreate.vue?vue&type=script&lang=js&"
import style0 from "./userAccessMgmtCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports